export const PROJECT_TYPE_OPTIONS = ["Development", "Design", "Consulting", "Marketing", "Mobile App", "Other"];
